export const applyMobileOnlyBackgroundBlur = () => {
  const bgVideoOverlay = document.querySelector(".background-video-overlay");
  bgVideoOverlay?.classList.add("mobile-only-bg-blur");
};

export const removeMobileOnlyBackgroundBlur = () => {
  const bgVideoOverlay = document.querySelector(".background-video-overlay");
  bgVideoOverlay?.classList.remove("mobile-only-bg-blur");
};
